<template>
    <CModal
        :title="title"
        :color="color"
        :show.sync="dialogVisible"
    >
        <p slot="default">{{ text }}</p>

        <div slot="footer">
            <CButton
                color="light"
                class="ml-3"
                @click="close">Отмена</CButton>

            <CButton
                color="danger"
                class="ml-3"
                @click="confirm">Удалить</CButton>
        </div>
    </CModal>
</template>

<script>
    export default {
        name: 'AppConfirmDialog',

        props: {
            color: {
                type: String,
                default: 'danger'
            },

            title: {
                type: String,
                default: 'Подтверждение'
            },

            text: {
                type: String,
                default: 'Вы действительно хотите удалить? Это действие нельзя будет отменить.'
            },
        },

        data: () => ({
            dialogVisible: false
        }),

        methods: {
            close() {
                this.dialogVisible = false
            },

            open() {
                this.dialogVisible = true
            },

            confirm() {
                this.$emit('confirm')
                this.close()
            }
        }
    }
</script>
